import React from 'react'
import NavigationBar from './NavigationBar'

import Container from 'react-bootstrap/Container'

// import Buuton from './Buuton'
import ApiCall from './ApiCall'



export const About = () =>(
    <div>
        <NavigationBar />

        <Container>
            <h1>About</h1>
            
            <h1>data from api call </h1>
            <ApiCall endPoint='https://jsonplaceholder.typicode.com/posts' />
        </Container>
    </div>
)
